import { AuthPage } from 'pages/auth';
import { FC } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

const AuthRoute: FC = () => {
  const location = useLocation();
  return (
    <Routes>
      <Route path="auth/*" element={<AuthPage />} />
      <Route path="*" element={<Navigate to="/auth" replace state={{ from: location }} />} />
    </Routes>
  );
};

export default AuthRoute;
